/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useRef } from "react";

import { SearchIcon } from "../icons";
import Title from "../components/Title";
import ArrivalList from "../components/ArrivalList";
import SpecialList from "../components/SpecialList";
import TopBar from "../components/TopBar";
import { useMediaQuery } from "react-responsive";
import {
  getCarMakers,
  getCountries,
  getVehicles,
  searchVehicles,
} from "../services/btc-api.service";
import { useSelector } from "react-redux";
import SelectCountry from "../components/Country";
import SelectMake from "../components/Make";
import { useNavigate } from "react-router-dom";
import { Carousel } from "primereact/carousel";
import CustomSearch from "../components/CustomSearch";
import Logistic from "../components/Logistic";
import { store } from "../redux/store";
import { setShowCustomSearch } from "../redux/modal";

export default function Home() {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [carMakers, setCarMakers] = useState([]);
  const [expanded, setExpanded] = useState(true);
  const [newArrivals, setNewArrivals] = useState([]);
  const [specialOffers, setSpecialOffers] = useState([]);
  const [selectedCarMaker, setSelectedCarMaker] = useState(undefined);
  const [selectedCountry, setSelectedCountry] = useState(undefined);
  const [searchText, setSearchText] = useState("");
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const user = useSelector((state) => state.user.user);
  const showCustomSearch = useSelector((state) => state.modal.showCustomSearch);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const [searchObj, setSearchObj] = useState({
    maker: null,
    model: null,
    auctionType: null,
    stock: null,
    yearsStart: 1960,
    yearsEnd: 2023,
    color: null,
    condition: null,
    mileageStart: 0,
    mileageEnd: 100000,
    fuelType: null,
    bodyType: null,
    priceStart: 0,
    priceEnd: 10000000,
    steeringWheel: null,
    drivingSystem: null,
    transmission: null,
  });

  const onClickReset = () => {
    setSearchObj({
      maker: null,
      model: "",
      auctionType: null,
      stock: "",
      yearsStart: 1960,
      yearsEnd: 2023,
      color: null,
      condition: null,
      mileageStart: 0,
      mileageEnd: 100000,
      fuelType: null,
      bodyType: null,
      priceStart: 0,
      priceEnd: 10000000,
      steeringWheel: null,
      drivingSystem: null,
      transmission: null,
    });
  };

  const loadData = async (obj) => {
    const objToSend = { ...obj };

    if (objToSend.maker) {
      objToSend.maker = objToSend.maker._id ?? null;
    }

    if (objToSend.auctionType) {
      objToSend.auctionType = objToSend.auctionType.code ?? null;
    }

    if (objToSend.condition) {
      objToSend.condition = objToSend.condition.code ?? null;
    }

    if (objToSend.fuelType) {
      objToSend.fuelType = objToSend.fuelType.code ?? null;
    }

    if (objToSend.bodyType) {
      objToSend.bodyType = objToSend.bodyType.code ?? null;
    }

    if (objToSend.color) {
      objToSend.color = objToSend.color.code ?? null;
    }

    if (!objToSend.page) {
      objToSend["page"] = 0;
    }

    objToSend["limit"] = 10;

    if (user && user._id) {
      objToSend["userId"] = user?._id;
    }

    searchVehicles(objToSend).then((res) => {
      store.dispatch(setShowCustomSearch());
      navigate("/search", {
        state: {
          vehicles: res,
        },
      });
    });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    fetchData();
  }, [user]);

  const fetchData = async () => {
    const countriesGot = await getCountries();
    const carMakersGot = await getCarMakers();

    setCountries(countriesGot);
    setCarMakers(carMakersGot);
    fetchNewArrivals();
    fetchSpecialOffers();
  };

  const onSearchButtonClicked = (countryId = null) => {
    let queryParams = "";

    if (selectedCountry && selectedCountry._id) {
      queryParams = `?country=${selectedCountry._id}`;
    }

    if (countryId) {
      queryParams = `?country=${countryId}`;
    }

    if (selectedCarMaker && selectedCarMaker._id) {
      if (!queryParams) {
        queryParams = `?maker=${selectedCarMaker._id}`;
      } else {
        queryParams = queryParams + `&maker=${selectedCarMaker._id}`;
      }
    }

    if (searchText) {
      if (!queryParams) {
        queryParams = `?searchText=${searchText}`;
      } else {
        queryParams = queryParams + `&searchText=${searchText}`;
      }
    }

    navigate(`/search/${queryParams}`);
  };

  const fetchNewArrivals = async () => {
    const res = await getVehicles(
      "NEW_ARRIVALS",
      user && user._id ? user._id : undefined,
      searchText,
      selectedCountry?._id,
      selectedCarMaker?._id,
      0,
      isMobile ? 10 : 16
    );

    if (res.records) {
      setNewArrivals(res.records);
    }
  };

  const fetchSpecialOffers = async () => {
    const res = await getVehicles(
      "SPECIAL_OFFERS",
      user && user._id ? user._id : undefined,
      searchText,
      selectedCountry,
      selectedCarMaker,
      0,
      16
    );

    if (res.records) {
      setSpecialOffers(res.records);
    }
  };

  return (
    <>
      {isLoggedIn && <TopBar />}
      <div style={{ paddingBottom: 10 }}>
        {" "}
        <div>
          {isMobile ? (
            <div className="image-background-mobile">
              <div className="search-bar-mobile">
                <MobileSearchBar
                  countries={countries}
                  carMakers={carMakers}
                  setSelectedCarMaker={setSelectedCarMaker}
                  setSelectedCountry={setSelectedCountry}
                  setSearchText={setSearchText}
                  onSearch={onSearchButtonClicked}
                  selectedCarMaker={selectedCarMaker}
                  selectedCountry={selectedCountry}
                />
              </div>
            </div>
          ) : (
            <div className="image-background">
              <div className="search-bar-2">
                <SearchBar
                  countries={countries}
                  carMakers={carMakers}
                  setSelectedCarMaker={setSelectedCarMaker}
                  setSelectedCountry={setSelectedCountry}
                  setSearchText={setSearchText}
                  onSearch={onSearchButtonClicked}
                  selectedCarMaker={selectedCarMaker}
                  selectedCountry={selectedCountry}
                />
              </div>
            </div>
          )}
        </div>
        {/* <div className="image-background">
          <div className="search-bar-2">
            {!isMobile && (
              <SearchBar
                countries={countries}
                carMakers={carMakers}
                setSelectedCarMaker={setSelectedCarMaker}
                setSelectedCountry={setSelectedCountry}
                setSearchText={setSearchText}
                onSearch={onSearchButtonClicked}
                selectedCarMaker={selectedCarMaker}
                selectedCountry={selectedCountry}
              />
            )}
            {isMobile && (
              <MobileSearchBar
                countries={countries}
                carMakers={carMakers}
                setSelectedCarMaker={setSelectedCarMaker}
                setSelectedCountry={setSelectedCountry}
                setSearchText={setSearchText}
                onSearch={onSearchButtonClicked}
                selectedCarMaker={selectedCarMaker}
                selectedCountry={selectedCountry}
              />
            )}
          </div>
        </div> */}
        {showCustomSearch && (
          <CustomSearch
            expanded={expanded}
            setExpanded={setExpanded}
            onSearch={loadData}
            searchObj={searchObj}
            setSearchObj={setSearchObj}
            onClickReset={onClickReset}
            alreadyExpand={true}
          />
        )}
        <div className="container-custom">
          <Title text="stock by country" />
          <CountryList onSearch={onSearchButtonClicked} />
          <Title text="New Arrivals" />
          <ArrivalList newArrivals={newArrivals} />
          <Title text="Special Offer" />
          <SpecialList isRelated={false} specialOffers={specialOffers} />
          <Logistic user={user} />
        </div>
      </div>
    </>
  );
}

const SearchBar = ({
  countries,
  carMakers,
  setSelectedCarMaker,
  setSelectedCountry,
  setSearchText,
  onSearch,
  selectedCarMaker,
  selectedCountry,
}) => {

  const [search, setSearch] = useState();
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prevShowCursor) => !prevShowCursor);
    }, 500);

    return () => {
      clearInterval(cursorInterval);
    };
  }, []);

  const handleSearchInputChange = (txt) => {
    setSearch(txt);
    setSearchText(txt);
  }

  return (
    <div className="search-bar">
      <div className="input-box-2">
        <label >Search Car</label>
        <input
          type="text"
          onChange={(e) => handleSearchInputChange(e.target.value)}
          placeholder={`Car Name / Mode / Make / Stock No.`}
        />
        {!search && <span className="blink">|</span>}
      </div>
      <button onClick={() => onSearch()}>
        <SearchIcon />
      </button>
      <SelectMake
        carMakers={carMakers}
        setSelectedCarMaker={setSelectedCarMaker}
        selectedCarMaker={selectedCarMaker}
      />
      <span>|</span>
      <SelectCountry
        countries={countries}
        setSelectedCountry={setSelectedCountry}
        selectedCountry={selectedCountry}
      />
    </div>
  );
};

const MobileSearchBar = ({ setSearchText, onSearch }) => {
  const showCustomSearch = useSelector((state) => state.modal.showCustomSearch);

  const [showCursor, setShowCursor] = useState(true);
  const [search, setSearch] = useState();

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prevShowCursor) => !prevShowCursor);
    }, 500);

    return () => {
      clearInterval(cursorInterval);
    };
  }, []);

  const handleSearchInputChange = (txt) => {
    setSearch(txt);
    setSearchText(txt);
  }

  return (
    <div className="search-bar">
      <div className="input-box-2" style={{ marginRight: 41 }}>
        <label className="bold-and-black">Search Car</label>
        <input
          className="blinking-cursor-input"
          type="text"
          onChange={(e) => handleSearchInputChange(e.target.value)}
          placeholder={`Make / Modal / Stock No.`}
          style={{ fontSize: 11 }}
        />
        {!search && <span className="blink">|</span>}
      </div>
      <button className="searchbutton" onClick={() => onSearch()}>
        <SearchIcon />
      </button>

      <div className="custom-filter"
        onClick={() => {
          store.dispatch(setShowCustomSearch({}));
        }}
      >

        <span
          className={`custom-search-text-${showCustomSearch}`}
          style={{ marginRight: 10, color: "#0944C2" }}
        >
          Custom Search
        </span>
        <div className="search-img">
          <img src="custom-search-icon.png" alt="custom" />
        </div>
      </div>
    </div>
  );
};

const CountryList = ({ onSearch }) => {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const countries = [
    {
      id: "646d07e089e7fb3eb4d1553a",
      name: "Japan",
      img: "japan.png",
    },
    {
      id: "646d088e89e7fb3eb4d15547",
      name: "Pakistan",
      img: "pakistan.png",
    },
    {
      id: "646d08ac89e7fb3eb4d1554d",
      name: "UK",
      img: "UK.png",
    },
    {
      id: "646d08ff89e7fb3eb4d15553",
      name: "canada",
      img: "canada.png",
    },
    {
      id: "646d091889e7fb3eb4d15559",
      name: "UAE",
      img: "UAE.png",
    },
    {
      id: "646d093e89e7fb3eb4d1555f",
      name: "Thailand",
      img: "thailand.png",
    },
    {
      id: "646d096b89e7fb3eb4d15569",
      name: "Kenya",
      img: "kenya.png",
    },
    {
      id: "646d098889e7fb3eb4d1556f",
      name: "Uganda",
      img: "uganda.png",
    },
    {
      id: "646d09a689e7fb3eb4d15575",
      name: "South Africa",
      img: "south-africa.png",
    },
  ];
  const responsiveOptions = [
    {
      breakpoint: "1024px",
      numVisible: 8,
      numScroll: 3,
    },
    {
      breakpoint: "768px",
      numVisible: 4,
      numScroll: 4,
    },
    {
      breakpoint: "560px",
      numVisible: 4,
      numScroll: 4,
    },
  ];

  const flagsContainerRef = useRef(null);
  const [scrollPosition, setScrollPosition] = useState(0);

  const countryTemplate = (item) => {
    return (
      <div className="country-carosel-top-margin">
        <button
          style={{ backgroundColor: "transparent", border: "none" }}
          onClick={() => onSearch(item.id)}
        >
          <img className="country-image" alt={item.img} src={item.img} />
          <p>{item.name}</p>
        </button>
      </div>
    );
  };

  useEffect(() => {
    const container = flagsContainerRef.current;
    const scrollAmount = 200;
    const totalFlags = countries.length;

    const interval = setInterval(() => {
      setScrollPosition((prev) => (prev + 1) % totalFlags);
      if (container) {
        container.scrollTo(scrollPosition * scrollAmount, 0);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [scrollPosition, countries]);

  const indicators = Array.from({ length: 3 }, (_, index) => (
    <div
      key={index}
      className={`indicator ${index === scrollPosition % 3 ? 'active' : ''
        }`}
    ></div>
  ));

  return isMobile === true ? (
    <Carousel
      showNavigators={false}
      autoplayInterval={3000}
      value={countries}
      numVisible={9}
      numScroll={1}
      responsiveOptions={responsiveOptions}
      itemTemplate={countryTemplate}
    />
  ) : (
    <Carousel
      showNavigators={false}
      showIndicators={false}
      value={countries}
      numVisible={9}
      numScroll={1}
      responsiveOptions={responsiveOptions}
      itemTemplate={countryTemplate}
    />
  );
};
